'use client';

import { useLayoutEffect } from 'react';

import { captureMarketingArrival } from '@ps/features/creator-onboarding/functions/marketingArrival';

/**
 * Banks where this visit came from, once per document load, for
 * `onboardingMarketingCapture` at signup — see `captureMarketingArrival`.
 *
 * **Why the root layout and not `/signup`.** A campaign lands creators on
 * marketing surfaces (`pop.store/?utm_…`, a bio page, `/pricing-plans`) and the
 * link they then click through to `/signup` forwards only some of its params —
 * which is how a record ends up holding one lone `utm_id`. Recording the arrival
 * where it actually happens is the only place the full campaign is still on the
 * URL.
 *
 * Mounted above the app's Suspense boundary so a streaming route cannot delay
 * it. The URL it records is captured when the module is evaluated, not here, so
 * a funnel effect cannot have rewritten it first — see `getDocumentArrivalHref`.
 */
export function MarketingArrivalCapture() {
  useLayoutEffect(() => {
    captureMarketingArrival();
  }, []);

  return null;
}
